<template>
  <div>
    <!-- Content Header (Page header) -->
    <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3">
                  <label
                    >Date <span class="red">*</span></label
                  >
                  <input
                    v-model="emiDate"
                    type="date"
                    @change="loadAgentMember"
                    name="emiDate"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('emiDate'),
                    }"
                    required
                  />
                  <has-error
                    :form="form"
                    field="emiDate"
                  ></has-error>
                </div>
                <!-- <div class="col-md-3">
                  <label for="date">Payment Start Date</label>
                  <input type="date" v-model="form.paymentStartDate" name="paymentStartDate" class="form-control" @change="getSingleMemberLoanDetails" placeholder="EMI Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Payment End Date</label>
                  <input type="date" v-model="form.paymentEndDate" name="paymentEndDate" class="form-control" @change="getSingleMemberLoanDetails" placeholder="EMI Date">
                </div> -->
                <div class="col-md-3" v-if="user.type == 'admin'">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranch(branch)"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="user.type == 'admin'">
                  <label for="Designation">Designation</label>
                  <v-select v-model="designation" name="designation_id" label="name" :options="designations" placeholder="Select Designation" v-on:input="getStaff"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="user.type == 'admin' || user.role_id == 5">
                  <span>
                    <label for="Designation">Staff</label>
                    <v-select v-model="staff" name="staff_id" label="name" :options="staffs" placeholder="Select Staff" v-on:input="getAgentMembersCollection"></v-select>
                    
                    <has-error
                      :form="form"
                      field="branch_id"
                    ></has-error>
                  </span>
                </div>
                <div class="col-md-3" v-if="user.type == 'admin'|| user.role_id == 5">
                  <br>
                  <span v-if="this.staff">
                    <button class="btn btn-primary" @click="printView">Get Print</button>
                  </span>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
    <!-- Main content -->
    <section class="content">
      <div class="info-box"  v-if="canAccess('member-loan-plan-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Member Due EMIs</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('branch-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-6">
              Amt : {{totalAmt}}
              <div class="input-group pull-right input-group-sm" style="width: 210px;">
                <input type="text" v-model="applicationNo" @keyup.enter="loadAgentMember()" name="applicationNo" class="form-control pull-right" placeholder="Search by Loan Application No">

                <div class="input-group-btn">
                  <button type="button" @click="loadAgentMember()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
              <!-- <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </label> -->
            </div>
            <div class="col-md-6">
              <div class="input-group pull-right input-group-sm" style="width: 330px;">
                <input type="text" v-model="table_search" @keyup.enter="loadAgentMember()" name="table_search" class="form-control pull-right" placeholder="Search by Member Name, Code, Mobile">

                <div class="input-group-btn">
                  <button type="button" @click="loadAgentMember()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>LoanID </th>
                <th>Mem Name </th>
                <th class="hidden-xs">Mem Code </th>
                <th class="hidden-xs">Mobile</th>
                <th class="hidden-xs">Type</th>
                <th class="hidden-xs">Collection Center</th>
                <th class="hidden-xs">EMI Date</th>
                <th>Dues</th>
                <th class="hidden-xs">EMI</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rowsAgentMemberRecords" :key="index">
                <td class="hidden-xs">{{ (index + 1) }}</td>
                <td><span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                <td>{{ row.member.name }}</td>
                <td class="hidden-xs">{{ row.member.code }}</td>
                <td class="hidden-xs">{{ row.member.mobile }}</td>
                <td class="hidden-xs">{{ row.type }}</td>
                <td class="hidden-xs"><span v-if="row.collection_center_id">{{ row.collection_center.name }}</span></td>
                <td class="hidden-xs">{{ row.emiDate | myDate}}</td>
                <td>{{ row.arrear }}</td>
                <td class="hidden-xs">{{ row.total }}</td>
                <td class="hidden-xs">
                  <i v-if="row.status === 'sattle' && row.member_collection_pending.length < 1">Unpaid</i>
                  <i v-else-if="row.status === 'sattle' && row.member_collection_pending.length > 0">Pending</i>
                  <i v-else-if="row.status === 'partial' && row.member_collection_pending.length > 0">Pending</i>
                  <i v-else>{{ row.status }}</i></td>
                <!-- <td class="hidden-xs">
                  <span
                      v-if="row.status == 'pending'"
                      ><i class="fa fa-exclamation-circle fa-2x text-danger" aria-hidden="true"></i></span
                    >
                    <span
                      v-if="row.status == 'paid'"
                      class="label label-success"
                      >Paid</span
                    >
                    <span
                      v-if="row.status == 'approved'"
                      ><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i>
                      <i v-if="row.voucher.length === 0" class="fa fa-exclamation-triangle fa-2x text-danger" title="Voucher Not Found" aria-hidden="true"></i>
                      </span
                    >
                    <span
                      v-if="row.status == 'partial'"
                      class="label label-info"
                      >Partial</span
                    >                    
                </td> -->
                <td>
                  <div class="btn-group dropup">
                    
                    <button type="button" class="btn btn-info btn-flat btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true">
                      Task <span class="caret"></span>
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <li v-if="canAccess('paytm-pay') && row.arrear > 0">
                        <a @click="paywithpaytm(row)">
                          <img mb-10  src="../../assets/paytm.png" width="40">
                        </a>
                      </li>
                      <li v-if="row.arrear > 0 && row.member_collection_pending.length <= 0 && user.type !== 'member'">
                        <a @click="newModal(row)" class="btn-outline-danger">
                          Collect Payment
                        </a>
                      </li>
                      <li v-if="row.arrear > 0 && row.member_collection_pending.length <= 0 && user.type !== 'member'">
                        <a @click="promiseToPay(row)">
                          Promise To Pay
                        </a>
                      </li>
                    </ul>
                  </div>
                  <!-- <button v-if="canAccess('paytm-pay') && row.arrear > 0">
                    <img mb-10  src="../../assets/paytm.png" width="40" @click="paywithpaytm(row)">
                  </button> -->
                  <button v-if="row.arrear > 0 && row.member_collection_pending.length <= 0 && user.type !== 'member'"
                    @click="newModal(row)"
                    class="btn btn-success btn-xs"
                    >Pay Now
                  </button>
                  <!-- <button v-if="row.arrear > 0 && row.member_collection_pending.length <= 0 && user.type !== 'member'"
                    @click="promiseToPay(row)"
                    class="btn btn-info btn-xs"
                    >Promise To Pay
                  </button> -->
                  <!-- <div v-else-if="row.member_collection_pending.length > 0 || row.status === 'pending'" class="text-warning">Pending</div>
                  <div v-else-if="row.arrear <= 0 && row.status === 'paid'" class="text-success">Paid</div>
                  <div v-else-if="row.arrear <= 0 && row.status === 'partial'" class="text-info">Partial</div> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
    <!-- /.modal -->
    <div class="modal fade" id="printView">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <button @click="printAgentCollectionList()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
          </div>
          <div class="modal-body" id="printAgentCollectionList">
              <!-- Profile Image -->
              <div class="card card-primary card-outline">
                <div class="card-body box-profile" v-if="getCompanyRecord"> 
                  <table class="table table-condensed">
                    <thead>
                      <!-- <td><img :src="logo" height="100"></td> -->
                      <td><strong>Agent Detail</strong> <br>Name - {{staff.name}}<br> 
                        Address: {{staff.address}}<br>
                        branch: {{branch.name}}
                      </td>
                      <td class="text-right"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                        <br> Website - {{getCompanyRecord.url}}
                        </small></h4></td>
                    </thead>
                  </table>
                  <hr width="100%">
                  <h3>Customer EMI Records </h3>
                  <p class="text-right"><strong>Total Amount : {{totalAmt}}</strong></p>
                  <table class="table table-condensed">
                    <thead>
                      <tr>
                        <td>Sr No.</td>
                        <!-- <td><strong>Member Code</strong></td> -->
                        <td><strong>Member</strong></td>
                        <!-- <td><strong>(C/O) ALIAS</strong></td> -->
                        <!-- 
                        <td><strong>Type</strong></td>
                        <td><strong>Group</strong></td> -->
                        <td><strong>Mob No</strong></td>
                        <td><strong>Loan No</strong></td>
                        <td><strong>EMI Date</strong></td>
                        <td><strong>Curr Due</strong></td>
                        <td><strong>EMI</strong></td>
                        <td><strong>Collect Amt</strong></td>
                      </tr>
                    </thead>
                    <tbody style="border-width:2px; color:black; border-style:solid;" v-if="rowsAgentMemberRecords">
                      <tr v-for="(rowsAgentMemberRecord,index) in rowsAgentMemberRecords" :key="rowsAgentMemberRecord.id" style="border-width:2px;border-style:solid;">
                        <td>{{index+1}}</td>
                        <!-- <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.code}}</span></td> -->
                        <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.name}}</span></td>
                        <!-- <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.alias}}</span></td> -->
                        <!-- 
                        <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.type}}</span></td>
                        <td><span v-if="rowsAgentMemberRecord.collection_center">{{rowsAgentMemberRecord.collection_center.name}}</span></td> -->
                        <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.mobile}}</span></td>
                        <td><span v-if="rowsAgentMemberRecord.member_loan_plan">{{rowsAgentMemberRecord.member_loan_plan.applicationNo}}</span></td>
                        <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.emiDate | myDate}}</span></td>
                        <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.arrear}}</span></td>
                        <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.total}}</span></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="promiseToPay">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 v-show="!editMode" class="modal-title">Promise To Pay</h4>
          </div>
          <form @submit.prevent="submitPromiseToPay()">
            <div class="modal-body">
              <!-- right column -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Amount <span class="red">*</span></label>
                          <input
                            v-model="form.amt"
                            type="text"
                            name="amt"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('amt') }"
                            readonly
                            required
                          />
                          <has-error :form="form" field="amt"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Promise Date <span class="red">*</span></label
                          >
                          <input
                            v-model="form.promiseDate"
                            type="date"
                            name="promiseDate"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('promiseDate'),
                            }"
                            required
                          />
                          <has-error
                            :form="form"
                            field="promiseDate"
                          ></has-error>
                        </div>
                        <div class="form-group">
                          <label>Promise Note </label>
                          <input
                            v-model="form.promiseNote"
                            type="text"
                            name="promiseNote"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('promiseNote') }"
                          />
                          <has-error :form="form" field="promiseNote"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Remark </label>
                          <input
                            v-model="form.remark"
                            type="text"
                            name="remark"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('remark') }"
                          />
                          <has-error :form="form" field="remark"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="box box-default" v-if="memberloanplan.member">
                          <div class="box-header with-border">
                            <i class="fa fa-bullhorn"></i> 
                            <h3 class="box-title">Customer Details</h3>
                          </div> 
                          <div class="box-body">
                            
                            <div class="text-center">
                              <img
                                class="profile-user-img img-fluid img-circle"
                                :src= this.photo
                                alt="User profile picture"
                              />
                            </div>
                            <div class="callout callout-info">
                              <h4>Member</h4>
                              <p>{{memberloanplan.member.name}}</p>
                              <h4>Mobile No</h4>
                              <p>{{memberloanplan.member.mobile}}</p>
                              <h4>Address</h4>
                              <p v-if="memberRecord">{{memberRecord.address}}</p>
                            </div> 
                            <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                              <h4>Group</h4>
                              <p>{{memberloanplan.collection_center.name}}</p>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
            </div>
            <div class="modal-footer text-center">
              <button
                type="submit"
                class="btn btn-success"
              >
                CREATE
              </button>
              
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="newModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 v-show="!editMode" class="modal-title">Payment Collection</h4>
          </div>
          <form @submit.prevent="collectPayment()">
            <div class="modal-body">
              <!-- right column -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group" v-if="plCategory === 'interest'">
                          <label
                            >Select Payment Type <span class="red">*</span></label
                          >
                          <select
                            v-model="form.collectionType"
                            name="form.collectionType"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('form.collectionType'),
                            }"
                          >
                            <option v-if="!form.collectionType" selected value="">
                              Select Payment Type
                            </option>
                            <option value="interest">Interest</option>
                            <option value="loan">Principal</option>
                          </select>
                          <has-error :form="form" field="form.collectionType"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Amount <span class="red">*</span></label>
                          <input
                            v-model="form.amt"
                            type="text"
                            name="amt"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('amt') }"
                            required
                          />
                          <has-error :form="form" field="amt"></has-error>
                        </div>

                        <div class="form-group">
                          <label>Select Ledger Account </label>
                          <select
                            v-model="form.branch_ledger_id"
                            name="branch_ledger_id"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('branch_ledger_id'),
                            }"
                          >
                            <option v-if="!form.branch_ledger_id" selected value="">
                              Select Ledger Account
                            </option>

                            <option
                              :value="bank_account.id"
                              v-for="bank_account in bank_accounts"
                              :key="bank_account.id"
                            >
                              {{bank_account.name}} {{bank_account.remark}}
                            </option>
                          </select>
                          <has-error :form="form" field="branch_ledger_id"></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Payment Date <span class="red">*</span></label
                          >
                          <input
                            v-model="form.paymentDate"
                            type="date"
                            name="paymentDate"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('paymentDate'),
                            }"
                            required
                          />
                          <has-error
                            :form="form"
                            field="paymentDate"
                          ></has-error>
                        </div>
                        <div class="form-group">
                          <label
                            >Attendance <span class="red">*</span></label
                          >
                          <select
                            v-model="form.attendance"
                            name="attendance"
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('attendance'),
                            }"
                          >
                            <option selected value="present">Present</option>
                            <option value="absent">Absent</option>
                          </select>
                          <has-error :form="form" field="attendance"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Remark </label>
                          <input
                            v-model="form.remark"
                            type="text"
                            name="remark"
                            class="form-control"
                            :class="{ 'is-invalid': form.errors.has('remark') }"
                          />
                          <has-error :form="form" field="remark"></has-error>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="box box-default" v-if="memberloanplan.member">
                          <div class="box-header with-border">
                            <i class="fa fa-bullhorn"></i> 
                            <h3 class="box-title">Customer Details</h3>
                          </div> 
                          <div class="box-body">
                            
                            <div class="text-center">
                              <img
                                class="profile-user-img img-fluid img-circle"
                                :src= this.photo
                                alt="User profile picture"
                              />
                            </div>
                            <div class="callout callout-info">
                              <h4>Member</h4>
                              <p>{{memberloanplan.member.name}}</p>
                              <h4>Mobile No</h4>
                              <p>{{memberloanplan.member.mobile}}</p>
                              <h4>Address</h4>
                              <p v-if="memberRecord">{{memberRecord.address}}</p>
                            </div> 
                            <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                              <h4>Group</h4>
                              <p>{{memberloanplan.collection_center.name}}</p>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
            </div>
            <div class="modal-footer text-center">
              <button
                type="submit"
                class="btn btn-success"
              >
                CREATE
              </button>
              
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <payreceiptview :seeRecord="payReceipt" :getCompanyRecord="getCompanyRecord"></payreceiptview>
  <!-- Paytm collection model -->
    <div class="modal fade" id="paywithpaytm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Collection Details</h4>
            </div>
            <form @submit.prevent="collectPaytmPayment()">
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <input
                              type="hidden"
                              name="branch_id"
                              v-model="paytm.branch_id"
                            />
                          <input
                              type="hidden"
                              name="member_loan_plan_id"
                              v-model="paytm.id"
                            />
                          <input
                              type="hidden"
                              name="member_id"
                              v-model="paytm.member_id"
                            />
                          <input
                              type="hidden"
                              name="disbursement_id"
                              v-model="paytm.disbursement_id"
                            />
                          <input
                              type="hidden"
                              name="collection_center_id"
                              v-model="paytm.collection_center_id"
                            />
                           <div class="form-group">
                            <label>Name <span class="red">*</span></label>
                            <input
                              v-model="paytm.name"
                              type="text"
                              name="name"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('name') }"
                              required
                              disabled
                            />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Mobile <span class="red">*</span></label>
                            <input
                              v-model="paytm.mobile"
                              type="text"
                              name="mobile"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('mobile') }"
                              required
                              disabled
                            />
                            <has-error :form="form" field="mobile"></has-error>
                          </div>
                           <div class="form-group">
                            <label>Email <span class="red">*</span></label>
                            <input
                              v-model="paytm.email"
                              type="text"
                              name="email"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('email') }"
                              required
                              disabled
                            />
                            <has-error :form="form" field="email"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Amount <span class="red">*</span></label>
                            <input
                              v-model="paytm.amt"
                              type="text"
                              name="amt"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('amt') }"
                              required
                              disabled
                            />
                            <has-error :form="form" field="amt"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  Pay Now
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
            <form id="paytmForm" method="POST" :action="`${$axios.defaults.baseURL}/paytm/payment`">
              <input v-for="(input, index) in paytm" :key="index" type="hidden" :name="index" :value="input">
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

  </div>
</template>

<script>
var _ = require('lodash')
import { mapState } from 'vuex'
import payreceiptview from '../components/PaymentReceipt.vue'
export default {
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      processing: false,
      myurl: this.$axios.defaults.baseURL,
      editMode: false,
      photo: this.$store.state.imageDefaultUrl + '150',
      logo: '',
      memberLoan: {},
      emiDate: new Date().toISOString().slice(0, 10),
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      memberRecord: [],
      designations: [],
      designation: {},
      plCategory: '',
      applicationNo: '',
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      branches: [],
      branch: {},
      members: {},
      staffs: [],
      staff: {},
      pl: {},
      totalAmt: 0,
      seeRecord: {},
      loanplans: [],
      printData: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      bank_accounts: [],
      loadDisbursements: {},
      getCompanyRecord: {},
      payReceipt: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        emi_id: '',
        amt: '',
        type: 'emi',
        promiseDate: '',
        promiseNote: '',
        collectionType: '',
        plan: {},
        planType: '',
        member_id: '',
        designation_id: '',
        status: '',
        attendance: 'present',
        date: '',
        remark: '',
        disbursement_id: '',
        branch_ledger_id: '',
        paymentDate: new Date().toISOString().slice(0, 10),
        // paymentStartDate: '',
        // paymentEndDate: '',
        emiStartDate: ''
      }),
      paytm: {
        name: '',
        mobile: '',
        email: '',
        amt: 0,
        branch_id: '',
        member_id: '',
        disbursement_id: '',
        collection_center_id: '',
        member_loan_plan_id: '',
        receivedBy: JSON.parse(localStorage.user).id,
        mode: ''
      },
      columns: [
        {
          label: 'EMI DATE',
          field: 'emiDate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARRIER',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: [],
      rowsMemberCollections: [],
      rowsAgentMemberRecords: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    paywithpaytm (row) {
      this.paytm.name = row.member.name
      this.paytm.mobile = row.member.mobile
      this.paytm.email = row.member.email
      this.paytm.branch_id = row.branch_id
      this.paytm.member_id = row.member_id
      this.paytm.disbursement_id = row.disbursement_id
      this.paytm.member_loan_plan_id = row.member_loan_plan_id
      this.paytm.amt = row.arrear
      this.paytm.mode = 'paytm'
      $('#paywithpaytm').modal({backdrop: 'static', keyboard: false})
    },
    collectPaytmPayment () {
      $('#paytmForm').submit()
    },
    promiseToPay (row) {
      this.form.emi_id = row.id
      this.form.branch_id = row.branch_id
      this.form.member_loan_plan_id = row.member_loan_plan_id
      this.form.member_id = row.member_id
      this.form.disbursement_id = row.disbursement_id
      this.form.collection_center_id = row.collection_center_id
      this.form.amt = row.arrear
      this.memberloanplan = row
      this.$axios.get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.memberRecord = data.data[0]
        this.photo = this.$store.state.imageBaseUrl + this.memberRecord.user_id + '/photo/' + this.memberRecord.photo
        // console.log(data.data)
      })
      .catch(
        function (error) { console.log(error) }
      )
      $('#promiseToPay').modal({backdrop: 'static', keyboard: false})
    },
    newModal (row) {
      this.plCategory = ''
      this.plCategory = row.disbursement.planCategory
      this.form.collectionType = ''
      this.form.branch_id = row.branch_id
      this.form.member_loan_plan_id = row.member_loan_plan_id
      this.form.member_id = row.member_id
      this.form.disbursement_id = row.disbursement_id
      this.form.collection_center_id = row.collection_center_id
      this.form.amt = row.arrear
      this.memberloanplan = row
      this.$axios.get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.memberRecord = data.data[0]
        this.photo = this.$store.state.imageBaseUrl + this.memberRecord.user_id + '/photo/' + this.memberRecord.photo
        // console.log(data.data)
      })
      .catch(
        function (error) { console.log(error) }
      )
      this.$axios
        .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
            if (value.ledger.id === 3) {
              this.form.branch_ledger_id = value.id
            }
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      $('#newModal').modal({backdrop: 'static', keyboard: false})
     // this.loadDisbursement()
    },
    getBranch (branch) {
      this.form.branch_id = ''
      if (branch) {
        this.form.branch_id = branch.id
      }
      this.form.collection_center_id = ''
      this.form.planType = ''
      this.memberloanplans = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      this.staffs = []
      this.staff = {}
      this.designations = []
      this.designation = {}
      this.rows = []
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
      this.$axios
        .get('designation?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.designations = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getStaff () {
      this.form.designation_id = this.designation.id
      var pageUrl = 'staff?all=all'
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.designation_id) {
        pageUrl += `&designation_id=${this.form.designation_id}`
      }
      this.$axios
        .get(`${pageUrl}`, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getAgentMembersCollection () {
      this.totalAmt = 0
      this.rowsAgentMemberRecords = []
      this.$axios
        .get('agentemi?all=all&status=unpaid&agent_id=' + this.staff.user.id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          console.log('=========== agent wise member record =============')
          this.rowsAgentMemberRecords = data.data
          this.totalAmt = _.sumBy(this.rowsAgentMemberRecords, function (o) { return o.arrear })
          console.log('data data')
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getMembers () {
      this.memberloanplans = []
      this.form.member_loan_plan_id = ''
      this.rows = []
      this.rowsMemberCollections = []
      this.form.collection_center_id = this.collectionCenter.id
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
    },
    printPdf (id) {
      this.$axios
        .get('membercollection/pdfreceipt/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          console.log(data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getEMIRecord () {
      this.loadAgentMember()
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      var pageUrl = 'memberemi?all=all'
      if (this.emiDate) {
        pageUrl += `&emiDate=${this.emiDate}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.planType) {
        pageUrl += `&type=${this.form.planType}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      if (this.emiDate) {
        this.$axios
        .get(`${pageUrl}`, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.getMemberLoanPlan()
      }
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      this.form.member_loan_plan_id = null
      return pln.name
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewGroupMember (id) {
      this.loadGroupMember(id)
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
    },
    printView () {
      $('#printView').modal({backdrop: 'static', keyboard: false})
    },
    getSingleMemberLoanDetails () {
      if (this.emiDate) {
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('record by date')
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('record without date')
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      this.$axios
        .get('membercollection?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      var ss = this.form.member_loan_plan_id
      if (this.memberloanplans.length >= 1) {
        if (!this.emiDate) {
          this.memberloanplan = _.find(this.memberloanplans, function (o) { return o.id === ss })
        }
        // console.log(this.memberloanplan)
      }
      this.form.member_id = this.memberloanplan.member_id
      this.form.disbursement_id = this.memberloanplan.disbursement_id
      if (this.form.planType === 'group') {
        if (this.form.collection_center_id === '' || this.form.collection_center_id === null) {
          this.form.collection_center_id = this.memberloanplan.collection_center_id
        }
      }
    },
    submitPromiseToPay () {
      if (this.processing === true) {
        return false
      }
      this.processing = true
      this.$axios
        .post('promisetopay', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'Remark Added Successfully'
          })
          this.form.branch_id = ''
          $('#promiseToPay').modal('hide')
          Fire.$emit('AfterCreate')
        })
        .catch(
          function (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.error
            })
            // Toast.fire({ icon: 'error', title: error.response.data.error })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      setTimeout(() => {
        this.processing = false
      }, 1000)
    },
    collectPayment () {
      let loader = this.$loading.show()
      if (this.processing === true) {
        return false
      }
      this.processing = true
      this.form.date = this.form.paymentDate
      if (this.memberloanplan.type === 'individual') {
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .post('memberattendance', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'Attendance Updated Successfully'
          })
        })
        .catch(
          function (error) {
            loader.hide()
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.error
            })
            // Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((data) => {
          loader.hide()
          $('#newModal').modal('hide')
          this.payReceipt = data.data.data
          Toast.fire({
            icon: 'success',
            title: 'Payment Collect Successfully'
          })
          this.form.branch_id = ''
          Fire.$emit('AfterCreate')
          if (this.payReceipt) {
            $('#payReceiptView').modal({backdrop: 'static', keyboard: false})
          }
        })
        .catch(
          function (error) {
            loader.hide()
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.error
            })
            // Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      setTimeout(() => {
        this.processing = false
      }, 2000)
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getMemberLoanPlan () {
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsApplicationNumber () {
      this.form.member_loan_plan_id = []
      this.rows = []
      this.rowsMemberCollections = []
      this.$axios
      .get('memberloanplan?all=all&searchTerm=' + this.applicationNumber, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.$axios
        .get('memberloanplan?all=all/' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // alert(data)
         // console.log('hellooo')
         // console.log(data.data)
          this.memberloanplan = data.data
          // console.log('memberloanplans' + this.memberloanplans)
          this.getSingleMemberLoanDetails()
        })
        .catch(function (error) {
          console.log(error)
        })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsMemberCode () {
      this.$axios
      .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
         // alert(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.getSingleMemberLoanDetails()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPlanType () {
      this.form.collection_center_id = ''
      this.form.member_loan_plan_id = ''
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      if (this.form.planType === 'individual') {
        this.collectionCenter = {'name': 'Select Group'}
      }
      if (this.form.planType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
      // this.form.member_id = null
    },
    getGroupLeader () {
     // var x = this.groupMembers
    },
    getMemberAndGroupAndAgent () {
      this.$axios.get('member?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios
        .get('staff?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    loadBranch () {
      var c = JSON.parse(localStorage.user)
      if (c.role.name === 'Admin') {
        this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      } else {
        this.form.branch_id = c.agent_profile.branch_id
        this.form.agent_id = c.id
        if (c.role.name === 'Manager') {
          this.getStaff()
        }
      }
    },
    loadLoan () {
      this.$axios.get('loanplan?all=all&status=true', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadAgentMember () {
      var c = JSON.parse(localStorage.user)
      this.totalAmt = 0
      var pageUrl = ''
      if (c.type === 'admin') {
        pageUrl += 'adminemi?all=all&status=unpaid'
        if (this.emiDate) {
          pageUrl += `&emiDate=${this.emiDate}`
        }
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (this.applicationNo) {
          pageUrl += `&applicationNo=${this.applicationNo}`
        }
        if (this.table_search) {
          pageUrl += `&searchTerm=${this.table_search}`
        }
        this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== admin wise member record =============')
          this.rowsAgentMemberRecords = data.data
          this.totalAmt = _.sumBy(this.rowsAgentMemberRecords, function (o) { return o.arrear })
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (c.type === 'staff') {
        this.rowsAgentMemberRecords = []
        this.$axios
        .get('agentemi?all=all&status=unpaid&agent_id=' + c.id + '&branch_id=' + c.agent_profile.branch_id + '&emiDate=' + this.emiDate + '&searchTerm=' + this.table_search + '&applicationNo=' + this.applicationNo, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== agent wise member record =============')
          _.forEach(data.data, function (value) {
            var dd = _.find(this.rowsAgentMemberRecords, function (o) {
              return o.member_loan_plan_id === value.member_loan_plan_id
            })
            if (!dd) {
              this.rowsAgentMemberRecords.push(value)
              if (value.arrear === '' || value.arrear === null) {
                value.arrear = 0
              }
              this.totalAmt += parseInt(value.arrear)
             // alert('2')
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (c.type === 'member') {
        this.rowsAgentMemberRecords = []
        this.$axios
          .get('memberdueemi?all=all&status=unpaid&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log('=========== member wise record =============')
            _.forEach(data.data, function (value) {
              var dd = _.find(this.rowsAgentMemberRecords, function (o) {
                return o.member_loan_plan_id === value.member_loan_plan_id
              })
              if (!dd) {
                this.rowsAgentMemberRecords.push(value)
                if (value.arrear === '' || value.arrear === null) {
                  value.arrear = 0
                }
                this.totalAmt += parseInt(value.arrear)
              // alert('2')
              }
            }.bind(this))
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    printAgentCollectionList () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printAgentCollectionList').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style>
                table {border-width:2px; color:black; border-style:solid;}
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    loadDisbursement () {
      this.$axios
        .get('disbursement?all=all&status=disbursed', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loadDisbursements = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  components: {
    payreceiptview
  },
  created () {
    // this.loadMember();
    this.loadAgentMember()
    this.loadBranch()
    this.loadLoan()
    this.loadCompanyProfile()
    Fire.$on('AfterCreate', () => {
      this.loadAgentMember()
    })
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// DuePaymentList.vue?01dcb6b4